// **************************************************
//
// IMPORT
//
// **************************************************
const THREE = require('three')
require('src/lib/JDLoader.min')
import leftPad from 'left-pad'

import Tile from './tile'

import {loadingManager, load, registerSize} from '../loader'
import scene from '../scene'
import {state as gameState, player} from '../main'
import {config as gameConfig} from '../config'
// import {types as tileTypes, tileSize, numDraw, direction, layout} from './config'
import * as config from './config'
import _ from 'lodash'
import raf from '../raf'
import {TweenMax, SteppedEase, Back, Cubic, RoughEase, Power0} from 'gsap'
import {maxAnisotropy} from '../renderer'

export let conf = config

// **************************************************
//
// MESH
//
// **************************************************
export let mesh = new THREE.Object3D()
mesh.scale.setScalar(gameConfig.worldScale)
// mesh.castShadow = true
// mesh.receiveShadow = true
scene.add(mesh)




// **************************************************
//
// INIT
//
// **************************************************
// console.warn = function () {}

export let tiles = []
export let strobeRoads = []

const initTrack = function () {

  let nextPosition = [0, 0]
  let currDirection = config.direction.N

  for (let tileId of config.layout) {
    const tileType = config.types[tileId]
    let tile = new Tile(tileId)
    tiles.push(tile)
    mesh.add(tile.mesh)

    tile.mesh.position.x = nextPosition[0] * config.tileSize
    tile.mesh.position.z = nextPosition[1] * config.tileSize
    tile.mesh.rotation.y = -currDirection * THREE.Math.DEG2RAD

    currDirection += tileType.directionChange + 360
    currDirection %= 360

    switch (currDirection) {
      case config.direction.N:
        nextPosition[1]--
        break
      case config.direction.W:
        nextPosition[0]--
        break
      case config.direction.S:
        nextPosition[1]++
        break
      case config.direction.E:
        nextPosition[0]++
        break
    }

    // PREPARE STROBE ROAD
    let strobeNames = [
      'straightStrobe',
      'straightStrobeLeft',
      'straightStrobeRight',
      'straightStrobeStadium'
    ]
    if (strobeNames.indexOf(tileId) >= 0) {
      let strobes = _.filter(tile.mesh.children, (child)=> {
        return child.name === 'strobe_road'
      })
      strobeRoads = strobeRoads.concat(strobes)
      for (let road of strobeRoads) {
        road.position.y += 0.001
        road.material.alphaTest = 0.01
      }
    }

  }

}




// **************************************************
//
// LOADING
//
// **************************************************
let modelLoader = new THREE.JSONLoader(loadingManager)
let soundLoader = new THREE.AudioLoader(loadingManager)
let textureLoader = new THREE.TextureLoader(loadingManager)
export let loaded = false

const checkAllLoaded = function () {

  // Check Models
  for (let key in config.objects) {
    if (!config.objects[key].geometry) return
  }

  // Check Textures
  for (let key in config.textures) {
    const texture = config.textures[key]
    if (!texture.map) return
    if (texture.urls && (texture.map.length < texture.urls.length)) return
  }

  // Check Sounds
  for (let key in config.sounds) {
    if (!config.sounds[key].buffer) return
  }

  // init
  loaded = true
  initTrack()
  // raf.on('tick', update)
  // animateEmoji()
}


// MODELS
for (let key in config.objects) {
  let model = config.objects[key]
  registerSize(model.url, model.size)
  load(model.url, modelLoader, (results)=> {

    let geometry = new THREE.BufferGeometry().fromGeometry(results[0])

    model.geometry = geometry // JSON
    // model.geometry = results[0].geometries[0] // JD
    model.geometry.computeFaceNormals()
    model.geometry.computeVertexNormals()
    checkAllLoaded()
  })
}

// const createMaterial = function (map, type = THREE.MeshPhongMaterial, blending, alphaMapEnabled) {
const createMaterial = function (texture) {

  let config = Object.assign({
    map: texture.map,
    fog: true,
    transparent: true,
    alphaTest: 0.5
  }, texture.options)

  if (texture.options && texture.options.bumpMap) {
    let src = texture.options.bumpMap === 'self' ? texture.map : texture.options.bumpMap
    config.bumpMap = src
  }

  let material = new texture.materialType(config)
  material.map.anisotropy = maxAnisotropy
  material.map.wrapS = material.map.wrapT = THREE.RepeatWrapping

  return material
}


// TEXTURES
for (let key in config.textures) {
  let texture = config.textures[key]

  // SINGLE URL
  if (texture.url) {
    registerSize(texture.url, texture.size)
    load(texture.url, textureLoader, (results)=> {
      texture.map = results[0]
      // let material = createMaterial(texture.map, texture.materialType, texture.blending, texture.alphaMapEnabled)
      let material = createMaterial(texture)
      texture.material = material

      // if (key === 'start_wall') console.log(material)

      checkAllLoaded()
    })

  // MULTI URLS
  } else {
    texture.map = []
    texture.materials = []
    for (let i = 0; i < texture.urls.length; i++) {
      // const url = texture.url.replace('XX', leftPad(i, 2, '0'))
      const url = texture.urls[i]
      load(url, textureLoader, (results)=> {
        texture.map[i] = results[0]
        let config = Object.assign({}, texture)
        config.map = results[0]
        // let material = createMaterial(texture.map[i], texture.materialType, texture.blending, texture.alphaMapEnabled)
        let material = createMaterial(config)
        texture.materials[i] = material
        checkAllLoaded()
      })
    }
  }

}

// SOUNDS
for (let key in config.sounds) {
  let sound = config.sounds[key]
  registerSize(sound.url, sound.size)
  load(sound.url, soundLoader, (results)=> {
    sound.buffer = results[0]
    checkAllLoaded()
  })
}

// **************************************************
//
// UPDATE
//
// **************************************************
export const animatedTextures = _.filter(config.textures, (texture)=> {
  return texture.animate !== undefined
})

export let angles = []
export const update = function (delta) {
  if (!loaded) return

  const percent = player.state.distance

  // CALC CURRENT INDEX
  const currPieceIdx = (Math.floor(percent * (config.layout.length - 1)) % tiles.length)


  // HIDE PREV
  const prevPieceIdx = ((currPieceIdx - 1) + tiles.length) % tiles.length
  tiles[prevPieceIdx].hide()
  tiles[prevPieceIdx].hideEmojis()


  // CHECK SHOW EMOJI
  const nextPieceIdx = ((currPieceIdx + 3) + tiles.length) % tiles.length
  tiles[nextPieceIdx].showEmojis()

  // SHOW NEXT TILES
  for (let i = 0; i < config.numDraw - 1; i++ ) {
    let pieceIdx = (currPieceIdx + i) % (tiles.length)
    let tile = tiles[pieceIdx]
    tile.show()
    if (i >= 2) angles[i - 2] = tile.tileType.directionChange
  }

  // UPDATE TICKER TEXTURE
  updateTextures(delta)

}

export const updateTextures = function (delta) {
  if (!loaded) return
  for (let texture of animatedTextures) {
    let percent = 0.6 + gameState.velocity.percent * 0.5
    texture.map.offset.x += (texture.animate) * delta * percent
  }
}


// export const animateEmoji = function () {
//   let frames = 8
//   TweenMax.to(config.textures.emoji.map.offset, 1, {
//     x: (frames - 1) / frames,
//     ease: SteppedEase.config(frames - 1),
//     onUpdateParams: ['{self}'],
//     repeat: -1,
//     onUpdate: (tween)=> {
//       // let x = tween.target.x
//       // ctx.clearRect(0, 0, canvas.width, canvas.height)
//       // ctx.drawImage(img, x * 200, 0, 200, 200, 0, 0, 200, 200)
//       // console.log(config.textures.emoji.map)
//       config.textures.emoji.map.needsUpdate = true
//     }
//   })
// }



export const startSound = function (time) {
  for (let tile of tiles) {
    tile.startSound(time)
  }
}

export const stopSound = function (time) {
  for (let tile of tiles) {
    tile.stopSound(time)
  }
}



export const showStrobe = function () {
  for (let road of strobeRoads) {
    TweenMax.to(road.material, 1, {
      opacity: 0.4,
      ease: Cubic.easeOut
    })
  }
}

export const hideStrobe = function () {
  for (let road of strobeRoads) {
    road.material.opacity = 0
  }
}

export const showAllEmojis = function () {
  for (let tile of tiles) {
    tile.showEmojis()
  }
}

export const hideAllEmojis = function () {
  for (let tile of tiles) {
    tile.hideEmojis()
  }
}





// WEBPACK FOOTER //
// ./src/components/game/track-tiled/index.js